<template>
  <Card class="pa-2 mr-1 ml-1 subheading" :style="{ height: cardHeight }">
    <div id="info-header">
      <span class="subheading">{{ $t("Weather Station") }}</span>
      {{ $t("Live Data") }}
    </div>
    <div class="header ws-data-card" :style="{ height: cardHeight }">
      <div v-for="items in wsItems" :key="items.id">
        <span v-if="Object.keys(items).length > 1">
          <div class="pl-2 pt-2">{{ items.name }}</div>
          <v-list class="ma-2 ws-table primary">
            <template
              v-for="(param, index) in Object.keys(items).filter(
                (el) => el !== 'id' && el !== 'name'
              )"
            >
              <v-list-tile :key="`${items.id}_${param}`">
                <v-flex md9>
                  <v-list-tile-content>
                    <v-list-tile-title
                      >{{ computedNameObject[items.id][param].name }}
                      <span class="grey--text caption"
                        >({{ computedNameObject[items.id][param].unit }})</span
                      >
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-flex>
                <v-flex md3>
                  <v-list-tile-content>
                    <v-list-tile-title
                      :class="
                        items[param] == 'No Data'
                          ? 'error--text text-xs-center'
                          : 'number--text text-xs-center'
                      "
                    >
                      {{
                        items[param] == "No Data" ? $t("No Data") : items[param]
                      }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-flex>
              </v-list-tile>
              <v-divider
                v-if="
                  index + 1 <
                  Object.keys(items).filter((el) => el !== 'id' && el !== 'name')
                    .length
                "
                :key="`div_${items.id}_${param}`"
              ></v-divider>
            </template>
          </v-list>
        </span>
      </div>
    </div>
  </Card>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import LiveDb from "@/services/LiveDb.js";
import { mapGettersMixin } from "@/util/mixin/index";

export default {
  mixins: [mapGettersMixin],
  props: {
    nameMap: {
      type: Object,
      default: function () {
        return {};
      },
    },
    parameter: {
      type: Array,
      default: function () {
        return [];
      },
    },
    parameterNameMap: {
      type: Object,
      default: function () {
        return {};
      },
    },
    cardHeight: {
      type: [String, Number],
      default: "calc(100vh - 705px)",
    },
  },
  data() {
    return {
      wsItems: [],
      nameObject: {},
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId"]),
    computedNameObject() {
      const cloneNameObject = _.cloneDeep(this.nameObject);
      this.wsItems.forEach((ws) => {
        this.parameter.forEach((param) => {
          if (
            cloneNameObject[ws.id] &&
            cloneNameObject[ws.id][param] &&
            cloneNameObject[ws.id][param].name
          ) {
            cloneNameObject[ws.id][param].name = this.$t(
              cloneNameObject[ws.id][param].name
            );
          }
        });
      });

      return cloneNameObject;
    },
  },
  async mounted() {
    await this.liveWsDataHandler();
    this.mqttHandler();
  },
  beforeDestroy() {
    this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/weather station`);
  },
  methods: {
    isFloat(value) {
      if (
        typeof value === "number" &&
        !Number.isNaN(value) &&
        !Number.isInteger(value)
      ) {
        return true;
      }

      return false;
    },
    toThreeDecimalPlaces(props) {
      if (props !== undefined && props !== null) {
        if (this.isFloat(Number(props))) {
          return props == 0 ? 0 : Number.parseFloat(props).toFixed(3);
        } else {
          return props;
        }
      } else {
        return "No Data";
      }
    },
    async liveWsDataHandler() {
      // Querying live inverter data
      let wsParamJson = {};
      this.parameter.forEach((key) => {
        wsParamJson[key] = key;
      });
      const wsParam = Buffer.from(JSON.stringify(wsParamJson)).toString(
        "base64"
      );
      const liveWsData = await LiveDb.getLiveDeviceData(
        this.getSelectedPlantId,
        "weather station",
        wsParam
      );

      this.wsItems = Object.keys(this.parameterNameMap).map((idConfigured) => {
        const tempObj = liveWsData.data.message[idConfigured]
          ? liveWsData.data.message[idConfigured]
          : {};
        tempObj["name"] = this.nameMap[idConfigured];
        Object.keys(tempObj)
          .filter((key) => key !== "id" && key !== "name")
          .forEach((dataKey) => {
            if (
              this.parameterNameMap[idConfigured][0].config[dataKey] &&
              this.parameterNameMap[idConfigured][0].config[dataKey].count &&
              this.parameterNameMap[idConfigured][0].config[dataKey].count > 1
            ) {
              tempObj[dataKey].split(",").forEach((data, index) => {
                const newKey = `${dataKey}-${index + 1}`;
                tempObj[newKey] = this.toThreeDecimalPlaces(data);
              });
              delete tempObj[dataKey];
            } else {
              tempObj[dataKey] = this.toThreeDecimalPlaces(tempObj[dataKey]);
            }
          });

        // Parameter Header
        const paramObj = {};
        paramObj[idConfigured] = {};
        this.parameter.forEach((param) => {
          if (
            this.parameterNameMap[idConfigured][0].config[param] &&
            this.parameterNameMap[idConfigured][0].config[param].count &&
            this.parameterNameMap[idConfigured][0].config[param].count > 1
          ) {
            this.parameterNameMap[idConfigured][0].config[
              param
            ].nameMap.forEach((key, idx) => {
              const obj = {};
              const name = key;
              const unit = this.parameterNameMap[idConfigured][0].config[param]
                .unit
                ? this.parameterNameMap[idConfigured][0].config[param].unit
                : "";
              obj["name"] = name;
              obj["unit"] = unit;
              const newParameter = `${param}-${idx + 1}`;
              paramObj[newParameter] = obj;
            });
          } else {
            const obj = {};
            const name =
              this.parameterNameMap[idConfigured][0].config[param].name;
            const unit = this.parameterNameMap[idConfigured][0].config[param]
              .unit
              ? this.parameterNameMap[idConfigured][0].config[param].unit
              : "";
            obj["name"] = name;
            obj["unit"] = unit;
            paramObj[param] = obj;
          }
        });
        this.$set(this.nameObject, idConfigured, paramObj);
        return tempObj;
      });
    },
    mqttHandler() {
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/weather station`);
      if (this.mqttBound) return;
      this.mqttBound = true;
      this.$mqtt.on("message", (topic, message) => {
        if (topic.startsWith("live/")) {
          if (topic.endsWith("weather station")) {
            const mqttData = JSON.parse(message.toString()).deviceList[0];
            if (mqttData.ignore_status !== 1) {
              const index = this.wsItems.findIndex(
                (obj) => obj.id === mqttData.device_id
              );

              if (index === -1) return;

              this.parameter.forEach((key) => {
                if (mqttData[key] !== undefined) {
                  if (
                    this.parameterNameMap[mqttData.device_id][0].config[key] &&
                    this.parameterNameMap[mqttData.device_id][0].config[key]
                      .count &&
                    this.parameterNameMap[mqttData.device_id][0].config[key]
                      .count > 1
                  ) {
                    mqttData[key].split(",").forEach((data, idx) => {
                      const newKey = `${key}-${idx + 1}`;
                      this.wsItems[index][newKey] =
                        this.toThreeDecimalPlaces(data);
                    });
                  } else {
                    this.wsItems[index][key] = this.toThreeDecimalPlaces(
                      mqttData[key]
                    );
                  }
                }
              });
            }
          }
        }
      });
      this.$mqtt.on("error", function (error) {
        console.log("ERROR: ", error);
      });

      this.$mqtt.on("offline", function () {
        console.log("offline");
      });

      this.$mqtt.on("reconnect", function () {
        console.log("reconnect");
      });
    },
  },
  watch: {
    getSelectedPlantId(newVal, oldVal) {
      this.$mqtt.unsubscribe(`live/${oldVal}/weather station`);
      this.wsItems = [];
      this.nameObject = {};
    },
    parameterNameMap(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        this.liveWsDataHandler();
        this.mqttHandler();
      }
    },
  },
};
</script>

<style scoped>
#info-header {
  padding-bottom: 16px;
}

#info-header span {
  border-bottom: 2px solid #417cde;
  display: inline-block;
  vertical-align: top;
}

.ws-data-card {
  overflow-x: auto;
  overflow-y: auto;
}

.ws-table {
  border: 1px solid #38405c !important;
}
</style>
